import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import { UpploadService } from "./service";
import { setI18N, translate } from "./helpers/i18n";
import { getElements, safeListen, compressImage } from "./helpers/elements";
import { colorSVG } from "./helpers/assets";
import createFocusTrap from "focus-trap";
import mitt from "mitt";
import { safeUpploadFileToFile, blobToUpploadFile } from "./helpers/files";

var DefaultService = /*#__PURE__*/function (_UpploadService) {
  _inherits(DefaultService, _UpploadService);

  var _super = _createSuper(DefaultService);

  function DefaultService() {
    var _this;

    _classCallCheck(this, DefaultService);

    _this = _super.apply(this, arguments);
    _this.name = "default";
    _this.invisible = true;

    _this.template = function () {
      return "<p>".concat(translate("services.default.heading"), "</p>");
    };

    return _this;
  }

  return DefaultService;
}(UpploadService);

var UploadingService = /*#__PURE__*/function (_UpploadService2) {
  _inherits(UploadingService, _UpploadService2);

  var _super2 = _createSuper(UploadingService);

  function UploadingService() {
    var _this2;

    _classCallCheck(this, UploadingService);

    _this2 = _super2.apply(this, arguments);
    _this2.name = "uploading";
    _this2.invisible = true;

    _this2.template = function () {
      return "<div class=\"uppload-loader\">\n  <div></div>\n    <p class=\"uppload-loader-text\">".concat(translate("uploading"), "<span class=\"progress\"></span></p>\n  </div>");
    };

    return _this2;
  }

  return UploadingService;
}(UpploadService);
/**
 * Uppload image uploading widget
 */


export var Uppload = /*#__PURE__*/function () {
  /**
   * Create a new Uppload instance
   * @param settings - Uppload instance settings
   */
  function Uppload(settings) {
    var _this3 = this;

    _classCallCheck(this, Uppload);

    this.services = [new DefaultService(), new UploadingService()];
    this.effects = [];
    this.isOpen = false;
    this.activeService = "default";
    this.activeEffect = "";
    this.file = {
      blob: new Blob()
    };
    this.lang = {};
    this.emitter = mitt();
    this.uploadProgress = 0;
    this.inline = false;
    this.transitionDuration = 300;
    this.settings = {};
    this.updateSettings(settings || {});
    var div = document.createElement("div");
    this.renderContainer();
    div.classList.add("uppload-container");
    var body = document.body;

    if (body) {
      body.appendChild(div);
    }

    this.container = div;
    this.focusTrap = createFocusTrap(this.container, {
      initialFocus: function initialFocus() {
        return _this3.container.querySelector("button");
      }
    });
    requestAnimationFrame(function () {
      return _this3.update();
    });
    /**
     * Loader during file processing in effects
     * https://github.com/elninotech/uppload/issues/111
     */

    this.emitter.on("processing", function () {
      var loader = _this3.container.querySelector(".processing-loader");

      if (loader) loader.classList.add("visible");
    });
    this.emitter.on("process", function () {
      var loader = _this3.container.querySelector(".processing-loader");

      if (loader) loader.classList.remove("visible");
    });
  }
  /**
   * Update widget settings such as i18n
   * @param settings - Uppload settings object
   */


  _createClass(Uppload, [{
    key: "updateSettings",
    value: function updateSettings(settings) {
      this.settings = Object.assign(Object.assign({}, this.settings), settings);
      this.emitter.emit("settingsUpdated", settings);
      if (settings.lang) setI18N(settings.lang);
      if (settings.defaultService) this.activeService = settings.defaultService;
      if (settings.lang) this.lang = settings.lang;
      if (settings.transitionDuration) this.transitionDuration = settings.transitionDuration;
      if (settings.uploader) this.uploader = settings.uploader;
      this.inline = !!settings.inline;
      this.update();
    }
  }, {
    key: "ready",
    value: function ready() {
      if (this.settings.value) this.bind(this.settings.value);
      this.renderContainer();
      this.emitter.emit("ready");
    }
    /**
     * Bind the image URL value to DOM elements
     * @param value - URL of the image
     */

  }, {
    key: "bind",
    value: function bind(value) {
      if (this.settings.bind) {
        var elements = getElements(this.settings.bind);
        elements.forEach(function (element) {
          if (element.nodeName === "IMG") {
            element.setAttribute("src", value);
          } else {
            element.setAttribute("value", value);
          }
        });
        this.emitter.emit("bind");
      }
    }
    /**
     * Use an uploader, service, or effect in your package
     * @param plugin - A single uploader, service, or effect or an array of them
     */

  }, {
    key: "use",
    value: function use(plugin) {
      var _this4 = this;

      if (Array.isArray(plugin)) {
        plugin.forEach(function (item) {
          return _this4.install(item);
        });
      } else {
        this.install(plugin);
      }
    }
    /**
     * Remove a plugin (effect or serve) from this instance
     * @param slug - Slug of the plugin to be removed
     */

  }, {
    key: "remove",
    value: function remove(slug) {
      this.services = this.services.filter(function (service) {
        return service.name !== slug;
      });
      this.effects = this.effects.filter(function (service) {
        return service.name !== slug;
      });
      this.update();
      this.emitter.emit("remove", slug);
    }
    /**
     * Update the plugins for this instance
     * @param pluginUpdateFunction - Function to update this instance's plugins
     */

  }, {
    key: "updatePlugins",
    value: function updatePlugins(pluginUpdateFunction) {
      var plugins = pluginUpdateFunction(this.services);
      var services = plugins.filter(function (plugin) {
        return plugin.type === "service";
      });
      var hasDefaultService = !!services.filter(function (service) {
        return service.name === "default";
      }).length;
      var hasUploadingService = !!services.filter(function (service) {
        return service.name === "uploading";
      }).length;
      if (!hasUploadingService) services.unshift(new UploadingService());
      if (!hasDefaultService) services.unshift(new DefaultService());
      this.services = services;
      this.effects = plugins.filter(function (plugin) {
        return plugin.type === "effect";
      });
      this.update();
    }
    /**
     * Install a new uploader, service, or effect to this instance
     * @param plugin - A single uploader, service, or effect
     */

  }, {
    key: "install",
    value: function install(plugin) {
      // Check if the browser supports this plugin
      if (!plugin.supports()) return;

      if (plugin.type === "service") {
        // Install this service if it isn't already installed
        var has = !!this.services.filter(function (service) {
          return service.name === plugin.name;
        }).length;
        if (!has) this.services.push(plugin);
        this.ready();
      } else if (plugin.type === "effect") {
        var _has = !!this.effects.filter(function (effect) {
          return effect.name === plugin.name;
        }).length;

        if (!_has) this.effects.push(plugin);
        this.ready();
      }
    }
    /**
     * Returns whether the modal is currently open
     */

  }, {
    key: "modalOpen",
    value: function modalOpen() {
      return this.isOpen;
    }
    /**
     * Open the Uppload widget
     */

  }, {
    key: "open",
    value: function open() {
      var _this5 = this;

      if (this.isOpen) return;
      this.isOpen = true;
      this.file = {
        blob: new Blob()
      };
      this.activeService = "default";
      this.activeEffect = "";
      var serviceRadio = this.container.querySelector("input[type=radio][value='".concat(this.activeService, "']"));
      if (serviceRadio) serviceRadio.setAttribute("checked", "checked");
      this.container.style.transition = "".concat(this.transitionDuration, "ms");
      this.container.style.opacity = "0";
      this.update();
      var firstService = this.settings.defaultService;
      if (this.services.length === 3) this.navigate(this.services[2].name);
      if (firstService) this.navigate(firstService);
      safeListen(document.body, "keyup", function (e) {
        if (e.key === "Escape" && _this5.open) _this5.close();
      });
      setTimeout(function () {
        _this5.container.style.opacity = "1";
      }, 1);
      this.emitter.emit("open");
    }
    /**
     * Close the Uppload widget
     */

  }, {
    key: "close",
    value: function close() {
      var _this6 = this;

      if (!this.isOpen) return;
      this.stopCurrentService();
      this.isOpen = false;
      this.emitter.emit("close");
      this.container.style.opacity = "0";
      setTimeout(function () {
        return _this6.update();
      }, this.transitionDuration);
    }
    /**
     * Toggles the Uppload widget
     */

  }, {
    key: "toggle",
    value: function toggle() {
      if (this.modalOpen()) this.close();else this.open();
    }
    /**
     * Re-render the widget
     */

  }, {
    key: "update",
    value: function update() {
      var _this7 = this;

      if (!this.container) return;
      this.hideHelp();
      if (this.settings.customClass) this.container.classList.add(this.settings.customClass);
      if (this.inline) this.container.classList.add("uppload-inline");
      var content = this.container.querySelector(".uppload-active-container");
      if (content) content.innerHTML = this.render();
      var aside = this.container.querySelector("aside");
      if (aside && this.activeService !== "default" && !this.activeEffect) aside.style.display = "block";
      var footerEffectsNav = this.container.querySelector(".effects-nav");

      if (aside && footerEffectsNav && this.activeEffect) {
        footerEffectsNav.style.display = "";
        aside.style.display = "none";
      } else if (aside && footerEffectsNav && this.activeService === "default") {
        aside.style.display = "none";
        footerEffectsNav.style.display = "none";
      } else if (aside && footerEffectsNav) {
        aside.style.display = "";
        footerEffectsNav.style.display = "none";
      }

      var effectsContainer = this.container.querySelector(".uppload-effect");
      if (effectsContainer) effectsContainer.style.display = this.activeEffect ? "" : "none";
      window.requestAnimationFrame(function () {
        return _this7.handlers();
      });

      if (!this.isOpen) {
        this.container.classList.remove("visible");
        this.focusTrap.deactivate();
      } else {
        this.container.classList.add("visible");
        this.focusTrap.activate();
      }

      var effectsNav = this.container.querySelector("footer.effects-nav .effects-tabs");

      if (effectsNav) {
        var parent = effectsNav.parentElement;

        if (parent) {
          var totalButtonsWidth = 0;
          var buttons = parent.querySelectorAll(".effects-continue");
          buttons.forEach(function (button) {
            var buttonSize = button.getBoundingClientRect();
            totalButtonsWidth += buttonSize.width;
          });
          var size = parent.getBoundingClientRect();
          effectsNav.style.width = "".concat(size.width - totalButtonsWidth, "px");
        }
      }

      var sideNavbar = this.container.querySelector("aside");
      if (sideNavbar && this.services.length === 3) sideNavbar.classList.add("uppload-services--single");
      var help = this.container.querySelector(".uppload-help");

      if (help) {
        help.classList.remove("visible");
        safeListen(help, "click", function () {
          return _this7.hideHelp();
        });
      }
    }
    /**
     * Returns the HTML template for the services navbar
     * @param sidebar - Whether this is an input radio (for sidebar) or buttons (for home)
     */

  }, {
    key: "getNavbar",
    value: function getNavbar() {
      var _this8 = this;

      var sidebar = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return "<".concat(sidebar ? "nav" : "div", " class=\"uppload-services\">\n      ").concat(this.services.filter(function (service) {
        return !service.invisible;
      }).map(function (service) {
        return "<div data-uppload-service=\"".concat(service.name, "\" class=\"uppload-service-name\">\n          ").concat(sidebar ? "<input type=\"radio\" id=\"uppload-service-radio-".concat(service.name, "\" value=\"").concat(service.name, "\" name=\"uppload-radio\">") : "", "\n          <").concat(sidebar ? "label for=\"uppload-service-radio-".concat(service.name, "\"") : "button", " data-uppload-service=\"").concat(service.name, "\">\n            ").concat(service.icon.indexOf("http") === 0 ? "<img class=\"service-icon\" alt=\"\" src=\"".concat(service.icon, "\">") : colorSVG(service.icon, service), "\n            <span>").concat(_this8.lang.services && _this8.lang.services[service.name] && _this8.lang.services[service.name].title ? _this8.lang.services[service.name].title : service.name, "</span>\n          </").concat(sidebar ? "label" : "button", ">\n        </div>");
      }).join(""), "\n    </").concat(sidebar ? "nav" : "div", ">");
    }
    /**
     * Returns the HTML template for the effects navbar
     */

  }, {
    key: "getEffectsNavbar",
    value: function getEffectsNavbar() {
      var _this9 = this;

      return "<div class=\"effects-continue\">\n    <button class=\"effects-continue--cancel\">".concat(translate("cancel"), "</button>\n  </div><div class=\"effects-tabs\"><div class=\"effects-tabs-flow\">\n      ").concat(this.effects.map(function (effect) {
        return "\n      <input type=\"radio\" id=\"uppload-effect-radio-".concat(effect.name, "\" value=\"").concat(effect.name, "\" name=\"uppload-effect-radio\">\n        <label for=\"uppload-effect-radio-").concat(effect.name, "\">\n          ").concat(effect.icon.indexOf("http") === 0 ? "<img class=\"effect-icon\" alt=\"\" src=\"".concat(effect.icon, "\">") : colorSVG(effect.icon, effect), "\n          <span>").concat(_this9.lang.effects && _this9.lang.effects[effect.name] && _this9.lang.effects[effect.name].title ? _this9.lang.effects[effect.name].title : effect.name, "</span>\n        </label>\n      ");
      }).join(""), "\n      </div></div><div class=\"effects-continue\">\n        <button class=\"effects-continue--upload\">").concat(translate("upload"), "</button>\n      </div>");
    }
    /**
     * Renders the main container for the widget
     */

  }, {
    key: "renderContainer",
    value: function renderContainer() {
      if (this.container) this.container.innerHTML = "\n      <div class=\"uppload-modal\">\n        <div class=\"processing-loader\"></div>\n        <aside style=\"display: none\">\n          ".concat(this.getNavbar(true), "\n        </aside>\n        <section>\n          ").concat(this.error ? "<div class=\"uppload-error\">".concat(this.error, "</div>") : "", "\n          <div class=\"uppload-active-container\"></div>\n          <footer style=\"display: none\" class=\"effects-nav\">").concat(this.getEffectsNavbar(), "</footer>\n        </section>\n        <div class=\"uppload-help-loading\">\n          <div class=\"uppload-loader\">\n            <div></div>\n            <p class=\"uppload-loader-text\">").concat(translate("help.loading"), "</p>\n          </div>\n        </div>\n        <div class=\"uppload-help\">\n          <div><button><span>").concat(translate("help.close"), "</span><span aria-hidden=\"true\">&times;</span></button></div>\n          <iframe></iframe>\n        </div>\n      </div>\n      <div class=\"uppload-modal-bg\">\n        <button class=\"uppload-close\" aria-label=\"").concat(translate("close"), "\">&times;</button>\n      </div>\n    ");
    }
    /**
     * Render the content inside the widget container
     */

  }, {
    key: "render",
    value: function render() {
      return "\n      ".concat(this.error ? "<div class=\"uppload-error\">".concat(this.error, "</div>") : "", "\n      ").concat(this.activeEffect ? "<div class=\"uppload-effect uppload-effect--".concat(this.activeEffect || "none", "\">\n      ").concat(this.activeEffect && this.file ? this.renderActiveEffect(this.file) : "", "\n    </div>") : "<div class=\"uppload-service uppload-service--".concat(this.activeService, "\">\n      ").concat(this.activeEffect && this.file ? "" : this.renderActiveService(), "\n      ").concat(this.activeService === "default" ? this.getNavbar() : "", "\n    </div>"));
    }
    /**
     * Render the currently active service
     */

  }, {
    key: "renderActiveService",
    value: function renderActiveService() {
      var _this10 = this;

      var activeServices = this.services.filter(function (service) {
        return service.name === _this10.activeService;
      });

      if (activeServices.length) {
        var activeService = activeServices[0];
        requestAnimationFrame(function () {
          if (typeof activeService.handlers === "function") activeService.handlers({
            next: _this10.next.bind(_this10),
            upload: _this10.upload.bind(_this10),
            uploadMultiple: _this10.uploadMultiple.bind(_this10),
            handle: _this10.handle.bind(_this10),
            showHelp: _this10.showHelp.bind(_this10),
            uppload: _this10,
            translate: translate
          });
        });
        return "".concat(typeof activeService.template === "function" ? activeService.template({
          translate: translate,
          uppload: this
        }) : "");
      }
    }
    /**
     * Render the currently active effect
     */

  }, {
    key: "renderActiveEffect",
    value: function renderActiveEffect(file) {
      var _this11 = this;

      var activeEffects = this.effects.filter(function (effect) {
        return effect.name === _this11.activeEffect;
      });

      if (activeEffects.length) {
        var activeEffect = activeEffects[0];
        requestAnimationFrame(function () {
          if (typeof activeEffect.handlers === "function") activeEffect.handlers({
            next: _this11.next.bind(_this11),
            upload: _this11.upload.bind(_this11),
            uploadMultiple: _this11.uploadMultiple.bind(_this11),
            handle: _this11.handle.bind(_this11),
            showHelp: _this11.showHelp.bind(_this11),
            uppload: _this11,
            translate: translate
          });
        });
        return "\n        <div class=\"active-effect-container\">".concat(typeof activeEffect.template === "function" ? activeEffect.template({
          file: file,
          translate: translate
        }) : "", "</div>\n      ");
      }
    }
    /**
     * Uploads multiple files to the server
     * @param file
     * @returns JSON response from server
     */

  }, {
    key: "uploadMultiple",
    value: function uploadMultiple(file) {
      var _this12 = this;

      this.emitter.emit("before-upload");
      return new Promise(function (resolve) {
        _this12.navigate("uploading");

        if (_this12.uploader && typeof _this12.uploader === "function") {
          _this12.uploader(file, _this12.updateProgress.bind(_this12)).then(function (response) {
            _this12.navigate("default");

            resolve(response);

            _this12.emitter.emit("upload", response);

            _this12.close();
          }).catch(function (error) {
            return _this12.handle(error);
          });
        } else {
          _this12.handle(new Error("no-uploader"));
        }
      });
    }
  }, {
    key: "hideHelp",
    value: function hideHelp() {
      var help = this.container.querySelector(".uppload-help");
      var helpLoading = this.container.querySelector(".uppload-help-loading");
      var sideNavbar = this.container.querySelector("aside");
      var section = this.container.querySelector("section");
      if (helpLoading) helpLoading.classList.remove("visible");
      if (help) help.classList.remove("visible");
      if (sideNavbar) sideNavbar.style.display = "";
      if (section) section.style.display = "";
      this.emitter.emit("hide-help");
    }
    /**
     * Show the help article for this plugin in a frame
     * @param url - URL of help webpage
     */

  }, {
    key: "showHelp",
    value: function showHelp(url) {
      var _this13 = this;

      this.emitter.emit("help", url);
      var aside = this.container.querySelector("aside");
      if (aside) aside.style.display = "none";
      var section = this.container.querySelector("section");
      if (section) section.style.display = "none";
      var helpLoading = this.container.querySelector(".uppload-help-loading");
      if (helpLoading) helpLoading.classList.add("visible");
      var help = this.container.querySelector(".uppload-help");

      if (help) {
        var iframe = help.querySelector("iframe");

        if (iframe) {
          iframe.setAttribute("src", "https://uppload.js.org/help".concat(url));
          var completed = false;

          var listener = function listener() {
            completed = true;
            help.classList.add("visible");
            if (helpLoading) helpLoading.classList.remove("visible");
          };

          safeListen(iframe, "load", listener);
          safeListen(iframe, "error", function () {
            completed = true;

            _this13.hideHelp();
          });
        }
      }
    }
    /**
     * Updates the file and goes to the active effect
     * @param file - The currently active file Blob
     */

  }, {
    key: "next",
    value: function next(file) {
      this.emitter.emit("next", file);
      this.file = file;

      if (this.activeEffect) {// There's already an active effect
      } else {
        // Find the first effect and navigate to that
        // Unless the file type is not an image
        if (this.effects.length && file.type && file.type.indexOf("image/") === 0) {
          this.activeEffect = this.effects[0].name;
          this.update();
        } else {
          return this.upload(safeUpploadFileToFile(file));
        }
      } // Set active state to current effect


      var activeRadio = this.container.querySelector("input[name='uppload-effect-radio'][value='".concat(this.activeEffect, "']"));
      if (activeRadio) activeRadio.setAttribute("checked", "checked");
    }
  }, {
    key: "compress",
    value: function compress(file) {
      if (this.settings.compressionFromMimes && this.settings.compressionFromMimes.indexOf(file.type) === -1) return new Promise(function (resolve) {
        return resolve(file);
      });
      if (typeof this.settings.compressor === "function") return this.settings.compressor(file);
      return compressImage(file, this.settings);
    }
    /**
     * Upload a file to the server
     * @param file - A Blob object containing the file to upload
     * @returns The file URL
     */

  }, {
    key: "upload",
    value: function upload(file) {
      var _this14 = this;

      this.emitter.emit("before-upload", file);
      return new Promise(function (resolve, reject) {
        _this14.navigate("uploading");

        var upploadFile = blobToUpploadFile(file);

        try {
          if (typeof file.name === "string") upploadFile = blobToUpploadFile(file, file.name, file.type, new Date(file.lastModified));
        } catch (error) {}

        if (_this14.uploader && typeof _this14.uploader === "function") {
          _this14.compress(file).then(function (file) {
            if (_this14.settings.compression) _this14.emitter.emit("compress", file);
            return file;
          }).then(function (blob) {
            upploadFile.blob = blob;
            return safeUpploadFileToFile(upploadFile);
          }).then(function (file) {
            return _this14.uploader(file, _this14.updateProgress.bind(_this14));
          }).then(function (url) {
            _this14.bind(url);

            _this14.navigate("default");

            resolve(url);

            _this14.emitter.emit("upload", url);

            _this14.close();
          }).catch(function (error) {
            return _this14.handle(error);
          });
        } else {
          reject("no-uploader");
        }
      });
    }
    /**
     * Gracefully display an error message
     * @param error - Error to display
     */

  }, {
    key: "handle",
    value: function handle(error) {
      var _this15 = this;

      this.error = translate(error.message) || error.message;
      this.emitter.emit("error", this.error);
      this.update();
      if (this.activeService === "uploading") this.navigate("default");
      setTimeout(function () {
        _this15.error = undefined;

        _this15.update();
      }, 4000);
    }
    /**
     * Adds event handlers for the widget
     */

  }, {
    key: "handlers",
    value: function handlers() {
      var _this16 = this;

      var openFunction = function openFunction() {
        return _this16.open();
      };

      var closeFunction = function closeFunction() {
        return _this16.close();
      };
      /**
       * Clicking on each sidebar link should open its service
       */


      var defaultServiceLinks = this.container.querySelectorAll(".uppload-service--default .uppload-service-name button");
      defaultServiceLinks.forEach(function (link) {
        var linkFunction = function linkFunction(e) {
          var service = link.getAttribute("data-uppload-service");

          if (service) {
            _this16.navigate(service);

            var serviceDiv = _this16.container.querySelector("[data-uppload-service=\"".concat(service, "\"]"));

            if (serviceDiv && serviceDiv.parentElement) {
              var top = 0;
              var left = 0;
              var serviceDivRect = serviceDiv.getBoundingClientRect();
              var serviceNavRect = serviceDiv.parentElement.getBoundingClientRect();
              top = serviceDivRect.top - serviceNavRect.top;
              left = serviceDivRect.left - serviceNavRect.left;
              var aside = serviceDiv.parentElement.parentElement;

              try {
                // Edge doesn't support scrollTo and throws an error
                if (aside) aside.scrollTo(left, top);
              } catch (error) {}
            }
          }

          var serviceRadio = _this16.container.querySelector("input[type=radio][value='".concat(service, "']"));

          if (serviceRadio) serviceRadio.setAttribute("checked", "checked");
          e.preventDefault();
          return false;
        };

        safeListen(link, "click", linkFunction);
      });
      /**
       * Clicking on each sidebar link should open its service
       */

      var inputRadios = this.container.querySelectorAll(".uppload-services input[type='radio']");
      inputRadios.forEach(function (radio) {
        var radioFunction = function radioFunction(e) {
          var inputRadio = _this16.container.querySelector("[name='uppload-radio']:checked");

          if (!inputRadio) return;
          var service = inputRadio.value;

          _this16.navigate(service);
        };

        safeListen(radio, "change", radioFunction);
      });
      /**
       * Clicking on each sidebar link should open its service
       */

      var effectInputRadios = this.container.querySelectorAll(".effects-nav input[type='radio']");
      effectInputRadios.forEach(function (radio) {
        var radioFunction = function radioFunction(e) {
          var inputRadio = _this16.container.querySelector("[name='uppload-effect-radio']:checked");

          if (!inputRadio) return;
          var effect = inputRadio.value;
          _this16.activeEffect = effect;

          _this16.update();
        };

        safeListen(radio, "change", radioFunction);
      });
      /**
       * Clicking on the background should close the modal
       */

      var background = this.container.querySelector(".uppload-modal-bg");
      var closeButton = this.container.querySelector(".uppload-close");

      if (background && !this.settings.disableModalClickClose) {
        safeListen(background, "click", closeFunction);
      } else if (closeButton) {
        safeListen(closeButton, "click", closeFunction);
      }
      /**
       * All elements in `call` should open the modal on click
       */


      if (this.settings.call) {
        var elements = getElements(this.settings.call);
        elements.forEach(function (element) {
          safeListen(element, "click", openFunction);
        });
      }
      /**
       * Clicking on the cancel button restarts the process
       */


      var cancelButton = this.container.querySelector(".effects-continue--cancel");
      if (cancelButton) safeListen(cancelButton, "click", function () {
        _this16.file = {
          blob: new Blob()
        };
        _this16.activeService = "default";
        _this16.activeEffect = "";

        _this16.update();
      });
      /**
       * Clicking on the cancel button restarts the process
       */

      var uploadButton = this.container.querySelector(".effects-continue--upload");
      if (uploadButton) safeListen(uploadButton, "click", function () {
        if (!_this16.file) return;
        _this16.activeService = "";
        _this16.activeEffect = "";

        _this16.upload(safeUpploadFileToFile(_this16.file));
      });
    }
    /**
     * Stops any actions being done by the currently active service
     * For example, if your webcame is being accessed, kill that process
     */

  }, {
    key: "stopCurrentService",
    value: function stopCurrentService() {
      var _this17 = this;

      var currentService = this.services.filter(function (item) {
        return item.name === _this17.activeService;
      });

      if (currentService.length) {
        var service = currentService[0];
        service.stop();
      }
    }
    /**
     * Navigate to an Uppload service page
     * @param service - Slug name of service (e.g., instagram)
     */

  }, {
    key: "navigate",
    value: function navigate(service) {
      if (!this.services.filter(function (item) {
        return item.name === service;
      }).length) throw new Error("invalid-service");
      this.stopCurrentService();
      this.activeService = service;
      this.update();
      var focusable = this.container.querySelector(".uppload-active-container input, .uppload-active-container button");
      if (focusable) focusable.focus();
    }
    /**
     * Add an event listener
     * @param type - Type of event listener (e.g., open)
     * @param handler - Event handler function
     */

  }, {
    key: "on",
    value: function on(type, handler) {
      return this.emitter.on(type, handler);
    }
    /**
     * Remove an event listener
     * @param type - Type of event listener (e.g., open)
     * @param handler - Event handler function
     */

  }, {
    key: "off",
    value: function off(type, handler) {
      return this.emitter.off(type, handler);
    }
    /**
     * Updates the upload progress
     * @param progressPercent Current progress in percent
     */

  }, {
    key: "updateProgress",
    value: function updateProgress(progressPercent) {
      this.uploadProgress = progressPercent;
      var progressText = this.container.querySelector(".uppload-loader-text .progress");
      if (progressText) progressText.innerHTML = "".concat(parseInt(progressPercent.toString()), "%");
      this.emitter.emit("progress", this.updateProgress);
    }
  }]);

  return Uppload;
}();